import React, { useContext } from 'react';
import { ProjectDetails } from './ProjectDetails'
import { ProjectContext } from '../context/ProjectContext';
import uuid from 'uuid/v1';

export const Projects = () => {
    const { projects, dispatch } = useContext(ProjectContext);

    return (
        (   <div id="project-listing">
                {
                    projects.map((project) => {
                        return(<ProjectDetails key={project.id} projectItem={project}/>)
                    })
                }
                  <button onClick={() => dispatch({type: 'ADD_PROJECT', project: { 
                id: uuid(), 
                createdOn: new Date(), 
                name: '', 
                section: '', 
                needle: '', 
                stitchName: '', 
                rowCount: 0, 
                stitchCount: 0, 
                yarn: '', 
                notes: ''}
                })}>Add a project</button>
            </div>
        ) 
    )
}